export const PREFIX = '__efapp__';

export enum GlobalPlatFormEnum {
    ANDROID = 'android',
    IOS = 'ios',
}
